;(function () {
	const header = () => {
		const header = document.querySelector('.shopify-section-header')
		const menu = document.querySelector('.list-menu--inline')
		const menuLinks = document.querySelectorAll('.list-menu-item')
		const search = document.querySelector('.header__search')

		let hideMenuTimeout

		if (header) {
			header.addEventListener('keydown', (e) => {
				if (e.code === 'Escape' && search && search.isOpen) {
					search.close()
				}
			})
		}

		const annBar = document.querySelector('.section-announcement')
		const annBarObserver = new IntersectionObserver((entries) => {
			const [entry] = entries

			if (entry && entry.isIntersecting) {
				document.documentElement.style.setProperty(
					'--ann-height',
					`${entry.intersectionRect.height}px`
				)
			} else {
				document.documentElement.style.setProperty('--ann-height', `0px`)
			}
		})
		if (annBar) annBarObserver.observe(annBar)

		// --- Add submenu arrows (desktop + mobile) + rotate on hover/open ---
		const ensureArrowStyles = () => {
			if (document.getElementById('submenu-arrow-styles')) return
			const style = document.createElement('style')
			style.id = 'submenu-arrow-styles'
			style.textContent = `
				.submenu-arrow{
					display:inline-flex;
					align-items:center;
					justify-content:center;
					margin-left:0.4rem;
					transition:transform 500ms ease;
					transform-origin: 50% 50%;
				}

				/* Mobile drawer / any <details> based menu */
				details[open] > summary .submenu-arrow{
					transform: rotate(180deg);
				}

				/* Desktop: rotate on hover/focus for top-level items (structure-agnostic) */
				.list-menu--inline .list-menu-item:hover .submenu-arrow,
				.list-menu--inline .list-menu-item:focus-within .submenu-arrow{
					transform: rotate(180deg);
				}

				/* Your desktop mega menu uses this class */
				.list-menu--megamenu-visible .submenu-arrow{
					transform: rotate(180deg);
				}

				/* Fallback for non-<details> toggles (JS adds this class) */
				.submenu-arrow--rotate{
					transform: rotate(180deg);
				}
			`
			document.head.appendChild(style)
		}

		const arrowSVG = `
			<svg class="submenu-arrow" aria-hidden="true" focusable="false" width="12" height="12" viewBox="0 0 10 10">
				<path d="M2 3.5L5 6.5L8 3.5" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
			</svg>
		`

		const addSubmenuArrows = (root = document) => {
			ensureArrowStyles()

			// Any menu item that contains a nested list (sub-menu) or a mega-menu
			const candidates = root.querySelectorAll(
				'.list-menu-item, .menu-drawer__menu-item, li, details'
			)

			candidates.forEach((el) => {
				// Detect a submenu in a resilient way
				const hasDetails = el.tagName === 'DETAILS'
				const submenu =
					el.querySelector(
						':scope > ul, :scope > .mega-menu, :scope > .header__submenu, :scope > .menu-drawer__submenu'
					) ||
					el.querySelector(
						'ul ul, .mega-menu, .header__submenu, .menu-drawer__submenu'
					)

				if (!submenu) return

				// Find the clickable label element (summary for <details>, otherwise a link/button)
				const trigger =
					el.querySelector(':scope > summary') ||
					el.querySelector('summary') ||
					el.querySelector(':scope > a') ||
					el.querySelector('a, button')

				if (!trigger) return
				if (trigger.querySelector('.submenu-arrow')) return

				// Only add arrows to top-level menu labels (desktop inline menu + mobile drawer root list)
				const parentUl = trigger.closest('ul')
				const isDesktopTop = parentUl && parentUl.classList.contains('list-menu--inline')
				const isMobileTop = parentUl && parentUl.classList.contains('menu-drawer__menu')
				if (!isDesktopTop && !isMobileTop) return

				trigger.insertAdjacentHTML('beforeend', arrowSVG)

				// Non-<details> fallback: keep arrow state in sync with class/style changes
				if (!hasDetails) {
					const parent = trigger.closest('.list-menu-item') || el

					const syncRotateState = () => {
						const arrow = trigger.querySelector('.submenu-arrow')
						if (!arrow) return

						const visible =
							parent.classList.contains('list-menu--megamenu-visible') ||
							parent.classList.contains('is-open') ||
							submenu.style.display === 'block' ||
							submenu.style.display === 'grid' ||
							submenu.getAttribute('aria-hidden') === 'false' ||
							parent.getAttribute('aria-expanded') === 'true'

						arrow.classList.toggle('submenu-arrow--rotate', !!visible)
					}

					// Initial sync
					syncRotateState()

					// Watch parent changes
					const observer = new MutationObserver(syncRotateState)
					observer.observe(parent, {
						attributes: true,
						attributeFilter: ['class', 'style', 'aria-expanded', 'aria-hidden'],
					})

					// Watch submenu changes
					const submenuObserver = new MutationObserver(syncRotateState)
					submenuObserver.observe(submenu, {
						attributes: true,
						attributeFilter: ['class', 'style', 'aria-expanded', 'aria-hidden'],
					})
				}
			})
		}

		// Run once now, and again shortly after to catch late-rendered drawer markup
		addSubmenuArrows(document)
		setTimeout(() => addSubmenuArrows(document), 250)

		// Observe header area for DOM changes (theme/editor can re-render parts)
		if (header) {
			const mo = new MutationObserver(() => addSubmenuArrows(header))
			mo.observe(header, { childList: true, subtree: true })
		}
		// --- end submenu arrows ---

		const megaMenus = document.querySelectorAll('.mega-menu')

		menuLinks.forEach((link) => {
			link.addEventListener('mouseenter', () => {
				clearTimeout(hideMenuTimeout)

				// Force-rotate arrow on hover (belt + braces)
				const arrow = link.querySelector('.submenu-arrow')
				if (arrow) arrow.classList.add('submenu-arrow--rotate')

				if (link.classList.contains('list-menu--megamenu')) {
					link.classList.add('list-menu--megamenu-visible')

					if (!megaMenus) return

					megaMenus.forEach((megaMenu) => {
						if (megaMenu == link.querySelector('.mega-menu')) {
							megaMenu.style.opacity = 0
							megaMenu.style.display = 'grid'
							setTimeout(() => {
								megaMenu.style.opacity = 1
							}, 100)
						}

						const headerMain = header ? header.querySelector('.header') : null
						if (!headerMain) return

						const calcPosition = () => {
							megaMenu.style.right = 'auto'

							const megaMenuTabs = megaMenu.querySelector('.mega-menu__tabs')

							if (megaMenuTabs) {
								if (megaMenuTabs.scrollWidth > megaMenu.offsetWidth) {
									megaMenu.style.maxWidth = `${megaMenuTabs.scrollWidth}px`
									megaMenu.style.width = `${megaMenuTabs.scrollWidth}px`
								}
							}

							const megaMenuRight = megaMenu.getBoundingClientRect().right
							const headerRight = headerMain.getBoundingClientRect().right

							if (megaMenuRight > headerRight) {
								megaMenu.style.right = '2rem'
							}
						}

						calcPosition()

						let headerMainWidth = headerMain.offsetWidth

						const resizeObserver = new ResizeObserver((entries) => {
							for (const entry of entries) {
								const newWidth = entry.contentRect.width

								if (newWidth !== headerMainWidth) {
									headerMainWidth = newWidth
									calcPosition()
								}
							}
						})

						resizeObserver.observe(headerMain)
					})

					menuLinks.forEach((el) => {
						if (el !== link) {
							el.classList.remove('list-menu--megamenu-visible')
							const elArrow = el.querySelector('.submenu-arrow')
							if (elArrow) elArrow.classList.remove('submenu-arrow--rotate')
						}
					})
				} else {
					menuLinks.forEach((el) => {
						el.classList.remove('list-menu--megamenu-visible')
					})
				}
			})

			link.addEventListener('mouseleave', () => {
				// Remove forced rotation when leaving the item
				const arrow = link.querySelector('.submenu-arrow')
				if (arrow) arrow.classList.remove('submenu-arrow--rotate')

				if (link.classList.contains('list-menu--megamenu')) {
					if (!megaMenus) return
					megaMenus.forEach((megaMenu) => {
						if (megaMenu == link.querySelector('.mega-menu')) {
							megaMenu.style.opacity = 0
							megaMenu.style.display = 'none'
							hideMenuTimeout = setTimeout(() => {
								megaMenu.style.display = 'none'
							}, 100)
						}
					})
				}
			})

			link.addEventListener('focus', () => {
				// Rotate on keyboard focus too
				const arrow = link.querySelector('.submenu-arrow')
				if (arrow) arrow.classList.add('submenu-arrow--rotate')

				if (link.classList.contains('list-menu--megamenu')) {
					link.classList.add('list-menu--megamenu-visible')

					if (!megaMenus) return
					megaMenus.forEach((megaMenu) => {
						const megaMenuPositionRight = megaMenu.getBoundingClientRect().right
						const windowRight = window.innerWidth
						if (megaMenuPositionRight > windowRight) {
							megaMenu.style.right = '0'
						}
					})

					menuLinks.forEach((el) => {
						if (el !== link) {
							el.classList.remove('list-menu--megamenu-visible')
							const elArrow = el.querySelector('.submenu-arrow')
							if (elArrow) elArrow.classList.remove('submenu-arrow--rotate')
						}
					})
				} else {
					menuLinks.forEach((el) => {
						el.classList.remove('list-menu--megamenu-visible')
					})
				}
			})
		})

		if (menu) {
			menu.addEventListener('mouseleave', () => {
				if (!megaMenus) return
				setTimeout(() => {
					megaMenus.forEach((megaMenu) => {
						megaMenu.style.right = 'auto'
						megaMenu.style.display = 'none'
					})
				}, 100)
				menuLinks.forEach((link) => {
					link.classList.remove('list-menu--megamenu-visible')
					const arrow = link.querySelector('.submenu-arrow')
					if (arrow) arrow.classList.remove('submenu-arrow--rotate')
				})
			})

			menu.addEventListener('focusout', () => {
				if (!megaMenus) return
				setTimeout(() => {
					megaMenus.forEach((megaMenu) => {
						megaMenu.style.right = 'auto'
					})
				}, 500)
				menuLinks.forEach((link) => {
					link.classList.remove('list-menu--megamenu-visible')
					const arrow = link.querySelector('.submenu-arrow')
					if (arrow) arrow.classList.remove('submenu-arrow--rotate')
				})
			})
		}

		const megaMenuTabs = () => {
			$('.mega-menu__tab-wrapper')
				.children()
				.find('.mega-menu__tab-wrapper')
				.first()
				.addClass('mega-menu__tab-wrapper--active')
			$('.mega-menu__tab-wrapper').mouseenter(function () {
				$('.mega-menu__tab-wrapper').removeClass('mega-menu__tab-wrapper--active')
				$(this).addClass('mega-menu__tab-wrapper--active')
			})
			$('.mega-menu__tab-wrapper').focus(function () {
				$('.mega-menu__tab-wrapper').removeClass('mega-menu__tab-wrapper--active')
				$(this).addClass('mega-menu__tab-wrapper--active')
			})
			$('.mega-menu__tab-wrapper').focusin(function () {
				$('.mega-menu__tab-wrapper').removeClass('mega-menu__tab-wrapper--active')
				$(this).addClass('mega-menu__tab-wrapper--active')
			})
		}
		megaMenuTabs()

		const main = document.querySelector('main')
		const breadcrumbs = document.querySelector('.breadcrumbs-wrapper')
		if (
			main &&
			main.querySelectorAll('.shopify-section')[0] &&
			main.querySelectorAll('.shopify-section')[0].classList.contains('section--has-overlay')
		) {
		}

		const menuCloseBtn = document.querySelector('.header__modal-close-button')
		const mobileMenuDrawer = document.querySelector('header-drawer')
		if (menuCloseBtn && mobileMenuDrawer) {
			menuCloseBtn.addEventListener('click', (e) => {
				mobileMenuDrawer.closeMenuDrawer(e)
			})
		}
	}

	document.addEventListener('shopify:section:load', header)
	document.addEventListener('shopify:section:unload', header)
	document.addEventListener('shopify:section:reorder', header)

	header()
})()
